<script>
export default {
  name: 'DiscretePalettePicker',
  data() {
    return {
      selected: this.setting.idx
    }
  },
  methods: {
    on_change() {
      this.$emit('change', this.selected)
    }
  },
  props: {
    setting: {type: Object, default: () => Object()}
  }
}
</script>

<template>
<v-list flat class='flex-grow-1'>
  <v-list-item-group v-model='selected' @change='on_change'>
    <template v-for='(option, i) in setting.options'>
      <v-list-item :key='option.label' :value='i' class='px-0 py-0'>
        <template v-slot:default='{ active, toggle }'>
          <v-list-item-action class='mr-3 pt-1'>
            <v-checkbox :input-value='active' :true-value='selected' @click='toggle'/>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title v-html='option.display_name'/>
            <div class='palette d-flex flex-grow-1 flex-nowrap align-stretch my-1'>
              <div v-for='(c, i) in option.colors' :key='i'
                class='flex-grow-1' :style='{backgroundColor: option(i)}'/>
            </div>
            <v-list-item-subtitle v-if='option.description' v-html='option.description'/>
          </v-list-item-content>
        </template>
      </v-list-item>
    </template>
  </v-list-item-group>
</v-list>
</template>

<style lang='sass' scoped>
.palette
  height: 1.5rem
</style>
